import styled from 'styled-components/macro'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

export const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 18px 16px 16px 16px;
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 1024px) {
    display: block;
  }
`

export const Title = styled.span`
  font-size: 18px;
`

export const Description = styled.span`
  font-size: 14px;
`

export const BannerContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.grey0};
  overflow: hidden;

  border: 1px solid ${({ theme }) => theme.colors.grey8};
  border-radius: 16px;
  margin-bottom: 12px;
  text-decoration: none;
  color: #000;

  &:hover {
    text-decoration: none;
    color: #000;
  }

  @media (min-width: 1024px) {
    height: 80px;
    flex-direction: row;
    text-decoration: none;
  }
`

export const ImgCustom = styled.img`
  max-width: 100%;
  height: 100%;
`

export const ImgContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 44px 17px 44px;
  background: #019df4;
  width: 100%;
  height: 100%;

  @media (min-width: 1024px) {
    justify-content: flex-start;
    order: -1;
    padding: 24px 70px 24px 32px;
    max-width: 450px;
  }
`

export const Stripes = styled.span`
  position: absolute;
  top: 0;
  width: 100%;

  &:before {
    content: '';
    position: absolute;
    background: ${({ theme }) =>
      `linear-gradient(0deg, ${theme.colors.primary.normal} 50%, ${theme.colors.tertiary.normal} 50%)`};
    width: 100%;
    height: 8px;
    top: 0;
  }

  @media (min-width: 1024px) {
    right: 0;
    width: 62px;
    height: 100%;
    background: linear-gradient(60deg, #019df4 50%, #fff 50%);

    &:before {
      content: '';
      position: absolute;
      background: ${({ theme }) =>
        `linear-gradient(0deg, ${theme.colors.primary.normal} 50%, ${theme.colors.tertiary.normal} 50%)`};
      width: 200%;
      height: 16px;
      transform-origin: top left;
      transform: rotate(60deg) translate(0%, -100%);
    }
  }
`

export const IconCustom = styled(Icon)`
  margin-right: 24px;
`
